import { Slide } from "react-toastify";

export const defaultOptions = {
    toastId: null,
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: true,
    pauseOnHover: true,
    theme: 'light',
    transition: Slide
}